import { render, staticRenderFns } from "./AboutBlock.vue?vue&type=template&id=9a5d32e6&scoped=true&"
import script from "./AboutBlock.vue?vue&type=script&lang=js&"
export * from "./AboutBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutBlock.vue?vue&type=style&index=0&id=9a5d32e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5d32e6",
  null
  
)

export default component.exports